import React from "react";
import { Link } from "react-router-dom";
import { PageIntro } from "../components/PageIntro";
import { SectionLabel } from "../components/SectionLabel";
import { MaturityModel } from "../components/research/MaturityModel";
import { ReportPreview } from "../components/research/ReportPreview";
import { ResearchFindings } from "../components/research/ResearchFindings";
import { IntelligenceTeaser } from "../components/research/IntelligenceTeaser";
import { researchPrograms, researchAgenda } from "../data/research";
const programCellBorders = ["", "md:border-l md:pl-8", "lg:border-l lg:pl-8", "md:border-l md:pl-8 lg:border-l-0 lg:pl-0", "lg:border-l lg:pl-8", "md:border-l md:pl-8"];
export function Research() {
  return <>
      <PageIntro label="Research & Intelligence" title="Defining payroll and HR technology operations through research." data-id="element-860" data-mp="3bkwqyk6j03ig">
        <p className="mt-10 max-w-2xl text-lg leading-relaxed text-charcoal/80 md:text-xl" data-id="element-861" data-mp="203x1dwbkc2s4">
          Constant’s research function studies how payroll and HR technology are staffed, run, and supported — and
          publishes frameworks, benchmarks, and data that leaders can act on.
        </p>
      </PageIntro>

      <section aria-labelledby="programs-title" className="shell pb-24 md:pb-32" data-id="element-862" data-mp="3o8yhzm36jwgd">
        <h2 id="programs-title" className="sr-only" data-id="element-863" data-mp="3j8j2oozc8evr">
          Research programs
        </h2>
        <ul className="grid grid-cols-1 border-t border-navy md:grid-cols-2 lg:grid-cols-3" data-id="element-864" data-mp="205gwqu7m0kw">
          {researchPrograms.map((p, i) => {
          const content = <>
                <p className="eyebrow text-oxblood" data-id="element-865" data-mp="asqxq1ea5x73">{p.type}</p>
                <h3 className="mt-5 font-display text-3xl leading-tight text-navy" data-id="element-866" data-mp="av3e4a4e3zi1">{p.name}</h3>
                <p className="mt-4 max-w-sm text-[15px] leading-relaxed text-charcoal/75" data-id="element-867" data-mp="6ti7v7md2jgt">{p.line}</p>
              </>;
          return <li key={p.name} className={`border-b border-stone py-10 pr-8 ${programCellBorders[i] ?? ""}`} data-id="element-868" data-mp="fsv8rbwf5zpx" data-mpi={i}>
                {p.href ? <a href={p.href} className="group block" data-id="element-869" data-mp="39lwg0hhv00y7">
                    {content}
                    <span className="link-rule mt-6" data-id="element-870" data-mp="3dlwwe7oiqm7w">View</span>
                  </a> : content}
              </li>;
        })}
        </ul>
      </section>

      <ResearchFindings data-id="element-871" data-mp="3ndb3b0isuob2" />
      <MaturityModel data-id="element-872" data-mp="3sataomh64vgy" />
      <ReportPreview data-id="element-873" data-mp="3s9hzi1le8lft" />
      <IntelligenceTeaser data-id="element-874" data-mp="3sa1fhcrhgzr7" />

      <section aria-labelledby="agenda-title" className="shell py-24 md:py-32" data-id="element-875" data-mp="3scvz522oagjk">
        <div className="grid grid-cols-12 gap-x-6 gap-y-8 pb-12" data-id="element-876" data-mp="12fangt12r8r">
          <div className="col-span-12 lg:col-span-3 lg:pt-3" data-id="element-877" data-mp="56wrb743cofb">
            <SectionLabel data-id="element-878" data-mp="a4oh9vl6e0gv">Research agenda</SectionLabel>
          </div>
          <div className="col-span-12 lg:col-span-9" data-id="element-879" data-mp="a2u5p7vsnkpg">
            <h2 id="agenda-title" className="font-display text-[clamp(2rem,3.8vw,3.25rem)] leading-[1.08] text-navy" data-id="element-880" data-mp="26xzyfmervkv4">
              What we’re studying next.
            </h2>
          </div>
        </div>
        <div className="overflow-x-auto" data-id="element-881" data-mp="24dtxlnlggais">
          <table className="w-full min-w-[720px] border-t border-navy text-left" data-id="element-882" data-mp="24evazypy193o">
            <thead data-id="element-883" data-mp="1zkr239x4aqzy">
              <tr className="border-b border-stone" data-id="element-884" data-mp="1zk8xnq0ax6gy">
                {["Study", "Area", "Status", "Expected"].map(h => <th key={h} scope="col" className="eyebrow py-4 pr-6 font-semibold text-oxblood" data-id="element-885" data-mp="1poeachl4un7u">
                    {h}
                  </th>)}
              </tr>
            </thead>
            <tbody data-id="element-886" data-mp="2ic1rtnr3wxq9">
              {researchAgenda.map(r => <tr key={r.study} className="border-b border-stone" data-id="element-887" data-mp="2iaqn9lpu7ly3">
                  <th scope="row" className="py-6 pr-6 font-display text-xl font-normal text-navy" data-id="element-888" data-mp="2dbvtxpu8uezq">
                    {r.study}
                  </th>
                  <td className="py-6 pr-6 text-[15px] text-charcoal/80" data-id="element-889" data-mp="11y1vemrgzq7r">{r.area}</td>
                  <td className="py-6 pr-6 text-[15px] text-charcoal/80" data-id="element-890" data-mp="xwpzjzi068r4">{r.status}</td>
                  <td className="py-6 text-[15px] tabular-nums text-charcoal/80" data-id="element-891" data-mp="xz2rn5hh5zhw">{r.expected}</td>
                </tr>)}
            </tbody>
          </table>
        </div>
      </section>

      <section id="briefings" aria-labelledby="briefings-title" className="shell scroll-mt-28 pb-24 md:pb-32" data-id="element-892" data-mp="2qlxqpe4xlhsb">
        <div className="grid grid-cols-12 gap-x-6 gap-y-10 bg-oxblood px-8 py-14 text-ivory md:px-14 md:py-20" data-id="element-893" data-mp="2gub82wq9kgfj">
          <div className="col-span-12 lg:col-span-6" data-id="element-894" data-mp="34k5lbfehw70b">
            <p className="eyebrow text-ivory/75" data-id="element-895" data-mp="34kozqm4xsd9l">Executive briefings</p>
            <h2 id="briefings-title" className="mt-6 font-display text-[clamp(2rem,3.6vw,3.25rem)] leading-[1.08]" data-id="element-896" data-mp="39hxlsxt7h1g4">
              What the research means for your organization.
            </h2>
          </div>
          <div className="col-span-12 flex flex-col justify-end lg:col-span-5 lg:col-start-8" data-id="element-897" data-mp="2zjhr6kuyza1v">
            <p className="leading-relaxed text-ivory/80" data-id="element-898" data-mp="1k39az109jrk7">
              Private sessions for CFOs, CHROs, and their teams — walking through the findings against your own payroll
              and HR technology.
            </p>
            <Link to="/contact" className="mt-8 inline-flex h-12 items-center self-start border border-ivory px-7 text-[12px] font-semibold uppercase tracking-[0.18em] text-ivory transition-colors duration-150 hover:bg-ivory hover:text-oxblood" data-id="element-899" data-mp="1go7rv9dv5gvh">
              Request a briefing
            </Link>
          </div>
        </div>
        <p className="mt-10 text-[15px] text-charcoal/75" data-id="element-900" data-mp="xwexpbn25pm6">
          Commentary on our research appears in{" "}
          <Link to="/ledger" className="text-oxblood underline underline-offset-4" data-id="element-901" data-mp="sy3pf5cevn62">
            The Ledger
          </Link>
          , Constant’s ongoing publication.
        </p>
      </section>
    </>;
}